<template>
    <div class="modal fade text-xs-left" :id="name" tabindex="-1" style="z-index: 10000">
        <div role="document" class="modal-dialog" style="margin: 5vh 5vw; position: relative; height: 90vh; width: 90vw; max-width: 90vw; max-height: 90vh" >
            <div class="modal-content h-100 w-100">  
                <div class="modal-body w-100 h-100">
                    
                    <v-touch style="position: absolute" class="h-100 w-100" v-on:swipeleft="next()" v-on:swiperight="prev()" ></v-touch>
                    <div ref="modalImgCont" class="row h-100">
                        <div style="position: absolute; right: 15px;" >
                            <button type="button" class="btn btn-warning" @click="closeForm()">
                                <i class="icon-cross" style="color: white"></i>
                            </button>
                        </div>
                        <div id="imgCont" class="w-100 h-100 d-flex justify-content-center align-items-center" >
                            <img id="imgSelf" :src="dataImg[arr_ind]" style="object-fit: cover; max-width: 100%; max-height: 100%;"/>
                            <!-- min-width: 40%; -->
                        </div>
                        <div style="position: absolute; left: 15px; top: 50%" v-show="arr_ind > 0">
                            <button type="button" class="btn btn-warning" @click="prev()">
                                <i class="icon-arrow-left2" style="color: white"></i>
                            </button>
                        </div>
                        <div style="position: absolute; right: 15px; top: 50%" v-show="arr_ind < dataImg.length - 1 ">
                            <button type="button" class="btn btn-warning" @click="next()">
                                <i class="icon-arrow-right2" style="color: white"></i>
                            </button>
                        </div>
                    </div>
                </div>
                <!--<div class="modal-footer"></div>-->
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    name: "modalImg",
    data(){
        return {
            arr_ind: 0,
            dataImg: [],
        }
    },
    components: { },
    props:{
        name:{type: String, required: true}
    },
    methods:{
        closeForm(){
            this.arr_ind = 0;
            $('#' + this.name).modal("hide");
        },
        onShow(ind, arr){
            this.arr_ind = ind;
            this.dataImg = arr;
        },
        next(){
            if((this.arr_ind + 1) < (this.dataImg.length)){
                this.arr_ind = this.arr_ind + 1;
            }
        },
        prev(){
            if((this.arr_ind - 1) > -1){
                this.arr_ind = this.arr_ind - 1;
            }
        }
    },
    computed: {
    },
    mounted(){
    },
    created(){
        $(document).on('click', '#'+ this.name, function (e) {
            e.preventDefault();
            var modalDialog = $(e.target).find('.modal-dialog');
            
            if(modalDialog != null){
                try{
                    var xOffset = modalDialog.offset().left;
                    var yOffset = modalDialog.offset().top;

                    if( (e.pageX < xOffset || e.pageX > (xOffset + modalDialog.width()) ) ||
                        (e.pageY < yOffset || e.pageY > (yOffset + modalDialog.height()) )
                    ){
                        //console.log('поза межами');
                        //$refs.closeQR.click()
                        this.closeForm();
                    }
                } catch(error){}
            }
        });        
    },
    watch: {
    },
  }
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/modalImg.vue